// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5c6f995","453":"8d73b056","455":"108fdf4e"}[chunkId] + ".chunk.js";
};